import { Component, Inject, HostListener, OnInit, OnDestroy } from '@angular/core';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { AimsHub } from '../../components/aimsHub/aimsHub';
import { TransferHttpService, CacheItem } from '../../services/transfer-http/transfer-http.service';
import { HrEmployees } from '../../../models';
import { Subject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';



@Component({
  selector: 'human-resources',
  templateUrl: './hr.component.html',
  styleUrls: ['./hr.component.css'],
  providers: [
    { provide: 'hrCount', useClass: AimsHub },
    { provide: 'trCount', useClass: AimsHub }
  ]
})

export class HRComponent implements OnInit, OnDestroy {


  constructor(public permissions: PermissionsService,
    public transferHttp: TransferHttpService,
    @Inject('hrCount') private hrCountHub: AimsHub,
    @Inject('trCount') private trCountHub: AimsHub,) { }

  des$: Subject<boolean> = new Subject();

  user = this.transferHttp.getCache<HrEmployees>(CacheItem.user);

  hrCounts: Observable<HrCounts> = this.hrCountHub.getHot(`hrCounts?currentUserId=${this.user.employeeId}&wsId=${this.user.workSectionId}&deptId=${this.user.departmentId}`).pipe(
    map(retList => retList[0])
  );

  trCounts: Observable<HrCounts> = this.trCountHub.getHot(`trCounts?currentUserId=${this.user.employeeId}&wsId=${this.user.workSectionId}&deptId=${this.user.departmentId}`).pipe(
    map(retList => retList[0])
  );

  dmCountString: Observable<string> = this.hrCounts.pipe(
    map(h => {
      let ret = `${h.myDmApproveCount}`;
      if (this.permissions.canRead(this.permissions.ComponentID.PscPmmApprovalQueue)) {
        ret += `)/(${h.allDmApproveCount}`;
      }
      return ret;
    }));


  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.des$.next(true);
    this.des$.complete();
  }

}

class HrCounts {

  hrRoutingCount: number = 0;
  myWsLeadCount: number = 0;
  myDmApproveCount: number = 0;
  allDmApproveCount: number = 0;
  hrmApproveCount: number = 0;
  pmmApproveCount: number = 0;
  acctReceivalCount: number = 0;
  itReceivalCount: number = 0;

  myWsSelfTrainedCert: number = 0;
  myDeptSelfTrainedCert: number = 0;
  selfTrainedCert: number = 0;

  myTrainerCert: number = 0;
  myDeptTrainerCert: number = 0;
  trainerCert: number = 0;

  myQualApproval: number = 0;
  myDeptQualApproval: number = 0;
  qualApproval: number = 0;

}
